import { render, staticRenderFns } from "./SlideWidth.vue?vue&type=template&id=e7dd49a8&"
import script from "./SlideWidth.vue?vue&type=script&lang=js&"
export * from "./SlideWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3602437192/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7dd49a8')) {
      api.createRecord('e7dd49a8', component.options)
    } else {
      api.reload('e7dd49a8', component.options)
    }
    module.hot.accept("./SlideWidth.vue?vue&type=template&id=e7dd49a8&", function () {
      api.rerender('e7dd49a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/components/transitions/SlideWidth.vue"
export default component.exports